import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate, useMatches } from 'react-router-dom';
import { AuthProviderWithRef } from './app/components/AuthProviderWithRef';
import ErrorBoundary from './features/ErrorBoundary';
import { baseName, cognitoAuthConfig, condition, coonditionContext } from '.';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { PostHogProvider } from 'posthog-js/react';
import { themePolygon } from './app/theme';
import { MagicLinkGuard } from './MagicLinkGuard';
import { AuthProfileDialog } from './components/iam/AuthProfileDisaply';
import { ConfirmDeleteProfile } from './components/iam/DeleteProfile';
import { useDispatch, useSelector } from 'react-redux';
import { dialogSelector, showAuthProfile } from './features/dialogSlice';

export let navigateRef: any = null;

// The component that manages all your application's top-level context
export function RootLayout() {
  
  // 1. Initialize navigateRef HERE
  // This hook is valid because RootLayout is the first element rendered by RouterProvider.
  // This ensures the ref is set before AuthProviderWithRef mounts.
  navigateRef = useNavigate(); 
  
  // Toggle #root between position:fixed (default in CSS) and position:static
  // based on the active route's handle.scrollable flag.
  const matches = useMatches();
  const scrollable = matches.some((m: any) => (m.handle as any)?.scrollable);
  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;
    root.classList.toggle('root-scrollable', scrollable);
  }, [scrollable]);

  const dispatch = useDispatch()
  const showAuthProfileState = useSelector(dialogSelector).showAuthProfile
  // ConfirmDeleteProfile mounts HERE (above MagicLinkGuard) so it has a stable host on EVERY route/auth state —
  // map AND HealthWallet. It previously lived only in AppLayout, so on HW routes it had no home and the signout
  // timer scheduled unreliably. Overlay with the default (dimmed) backdrop — the underlying route stays mounted.
  const showDeleteAccountState = useSelector(dialogSelector).showDeleteAccount
  return (
    // 2. AuthProviderWithRef wraps everything that uses the Auth Context (like MagicLinkGuard)
    //<AuthProviderWithRef {...cognitoAuthConfig()}> 
      <ErrorBoundary>
        <CssBaseline />
        <coonditionContext.Provider value={{ condition: condition, baseName: baseName }}>
          <PostHogProvider
            apiKey={'phc_dcQPE2uIIkdFRFuI4gUpEG3D7T6SKZgxZmJBUNcYlzd'}
            options={{
              api_host: "https://us.i.posthog.com",
            }}
          >
            <ThemeProvider theme={themePolygon}>
              {/* 3. The Outlet renders the nested routes, including MagicLinkGuard */}
              {/* <MagicLinkGuard>  */}
                 {(showAuthProfileState) && <AuthProfileDialog open={showAuthProfileState} onClose={() => dispatch(showAuthProfile(false))}/>}
                 {showDeleteAccountState && <ConfirmDeleteProfile />}
                <Outlet />
              {/* </MagicLinkGuard>  */}
            </ThemeProvider>
          </PostHogProvider>
        </coonditionContext.Provider>
      </ErrorBoundary>
    //</AuthProviderWithRef>
  );
}